import React, { FC } from 'react';
import { useTranslation } from '../../../translations';
import { Fetcher, useFetcher } from '../../../utils';

export const KioskSettings: FC = () => {
  const { ts } = useTranslation();

  const kioskList = useFetcher(async () => {
    return await api.getKioskList();
  }, []);

  if (kioskList.success) {
    return <Fetcher result={kioskList} />;
  }

  return <div>{ts('aaaa')}</div>;
};
